import React, { useState, useEffect } from 'react';
import { authAPI } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Card, PageHeader, ColorBtn } from '../components/UI';
import T from '../theme';


function TelegramCard() {
  const [linked, setLinked] = useState(false);
  const [linkData, setLinkData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [unlinking, setUnlinking] = useState(false);

  useEffect(() => { checkStatus(); }, []);

  const checkStatus = async () => {
    try { const r = await authAPI.telegramStatus(); setLinked(r.data.linked); } catch {}
  };

  const getLink = async () => {
    setLoading(true);
    try { const r = await authAPI.telegramLink(); setLinkData(r.data); } catch {}
    setLoading(false);
  };

  const unlink = async () => {
    setUnlinking(true);
    try { await authAPI.telegramUnlink(); setLinked(false); setLinkData(null); } catch {}
    setUnlinking(false);
  };

  return (
    <Card>
      <h3 style={{ fontSize: 16, fontWeight: 800, color: T.text, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
        📱 Telegram ulanish
      </h3>

      {linked ? (
        <div>
          <div style={{ background: T.greenSoft, borderRadius: 16, padding: 20, border: '1px solid #6EE7B7', textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>✅</div>
            <h4 style={{ fontSize: 16, fontWeight: 800, color: '#065F46', marginBottom: 6 }}>Telegram ulangan!</h4>
            <p style={{ fontSize: 13, color: '#047857', lineHeight: 1.5 }}>Xabarnomalar Telegram orqali yuboriladi</p>
          </div>
          <button onClick={unlink} disabled={unlinking} style={{
            width: '100%', marginTop: 12, padding: '12px', background: '#FEF2F2', border: '1.5px solid #FECACA',
            borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#DC2626', cursor: 'pointer', fontFamily: T.font,
          }}>{unlinking ? 'Uzilmoqda...' : 'Telegramni uzish'}</button>
        </div>
      ) : linkData ? (
        <div style={{ background: '#EFF6FF', borderRadius: 16, padding: 20, border: '1px solid #BFDBFE', textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔗</div>
          <p style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 12 }}>Quyidagi tugmani bosib botga o'ting:</p>
          <a href={linkData.link} target="_blank" rel="noopener noreferrer" style={{
            display: 'inline-block', padding: '14px 32px', background: '#0088cc', color: '#fff',
            borderRadius: 14, fontSize: 16, fontWeight: 800, textDecoration: 'none', fontFamily: T.font,
            boxShadow: '0 4px 16px rgba(0,136,204,0.3)',
          }}>📲 Telegram Bot</a>
          <p style={{ fontSize: 12, color: T.textMuted, marginTop: 12 }}>Kod: <b>{linkData.code}</b> (5 daqiqa amal qiladi)</p>
          <button onClick={checkStatus} style={{
            marginTop: 12, padding: '10px 24px', background: T.blue, color: '#fff', border: 'none',
            borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: T.font,
          }}>Tekshirish</button>
        </div>
      ) : (
        <div style={{ background: T.blueSoft, borderRadius: 16, padding: 20, border: '1px solid ' + T.blueBorder, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🤖</div>
          <h4 style={{ fontSize: 16, fontWeight: 800, color: T.text, marginBottom: 8 }}>SafeChild Bot</h4>
          <p style={{ fontSize: 14, color: T.textSec, marginBottom: 16, lineHeight: 1.6 }}>Telegram bot orqali bolangiz joylashuvi haqida xabarnomalar oling</p>
          <button onClick={getLink} disabled={loading} style={{
            padding: '14px 32px', background: '#0088cc', color: '#fff', border: 'none',
            borderRadius: 14, fontSize: 16, fontWeight: 800, cursor: loading ? 'default' : 'pointer', fontFamily: T.font,
            boxShadow: '0 4px 16px rgba(0,136,204,0.3)',
          }}>{loading ? 'Yuklanmoqda...' : '📲 Telegram ulash'}</button>
        </div>
      )}
    </Card>
  );
}

export default function SettingsPage() {
  const { user, isAdmin, logout } = useAuth();
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div>
      <PageHeader title="⚙️ Sozlamalar" subtitle="Profil va tizim sozlamalari" />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
        {/* Profile */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: T.text, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
            👤 Profil ma'lumotlari
          </h3>

          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
            <div style={{
              width: 72, height: 72, borderRadius: 20,
              background: `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 28, color: '#fff', fontWeight: 900,
              boxShadow: `0 8px 24px ${T.blue}30`,
            }}>
              {user?.first_name?.[0]?.toUpperCase() || user?.username?.[0]?.toUpperCase() || '?'}
            </div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 800, color: T.text }}>
                {user?.first_name} {user?.last_name}
              </div>
              <div style={{ fontSize: 14, color: T.textMuted, fontWeight: 600 }}>
                @{user?.username}
              </div>
              <span style={{
                display: 'inline-block', marginTop: 6,
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700,
                background: isAdmin ? T.blueSoft : T.yellowSoft,
                color: isAdmin ? T.blue : '#92400E',
                border: `1px solid ${isAdmin ? T.blueBorder : '#FCD34D'}`,
              }}>
                {isAdmin ? '🛡 Admin' : '👨‍👩‍👧 Ota-ona'}
              </span>
            </div>
          </div>

          <div style={{ display: 'grid', gap: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>ISM</label>
              <input
                defaultValue={user?.first_name}
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>FAMILIYA</label>
              <input
                defaultValue={user?.last_name}
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>TELEFON</label>
              <input
                defaultValue={user?.phone}
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
          </div>

          <div style={{ marginTop: 20, display: 'flex', gap: 12 }}>
            <ColorBtn onClick={handleSave} style={{ flex: 1, borderRadius: 12 }}>
              {saved ? '✓ Saqlandi' : '💾 Saqlash'}
            </ColorBtn>
          </div>
        </Card>

        {/* Security */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: T.text, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
            🔐 Xavfsizlik
          </h3>

          <div style={{ display: 'grid', gap: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>JORIY PAROL</label>
              <input
                type="password"
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>YANGI PAROL</label>
              <input
                type="password"
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>PAROLNI TASDIQLASH</label>
              <input
                type="password"
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '12px 16px',
                  background: T.bg, border: `2px solid ${T.border}`,
                  borderRadius: 12, fontSize: 15, fontFamily: T.font,
                  fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
          </div>

          <div style={{ marginTop: 20 }}>
            <ColorBtn color="#6366F1" style={{ width: '100%', borderRadius: 12 }}>
              🔑 Parolni o'zgartirish
            </ColorBtn>
          </div>
        </Card>

        {/* Telegram */}
        <TelegramCard />

        {/* Danger zone */}
        <Card style={{ borderColor: '#FCA5A5' }}>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#DC2626', margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
            ⚠️ Xavfli zona
          </h3>

          <button
            onClick={logout}
            style={{
              width: '100%', padding: '14px',
              background: T.coralSoft, border: '2px solid #FCA5A5',
              borderRadius: 12, fontSize: 15, fontWeight: 700, color: '#DC2626',
              cursor: 'pointer', fontFamily: T.font,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}
          >
            🚪 Tizimdan chiqish
          </button>
        </Card>
      </div>
    </div>
  );
}
